<template>
  <div>
    <populate-form
      collapseStyle="simple"
      formTitle="店家核銷失敗紀錄"
      fkey="tm01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
    ></populate-form>
    <!-- <div class="wrapper2" ref="wrapper">
      <b-table  sticky-header="65vh" ref="scrollarea" class="" striped hover :items="items" :fields="fields">
      </b-table>
    </div> -->
  </div>
</template>

<script>

import { 
  apiGetConfirmError
} from '@/api/SalesManage.js'

import {
  apiListToExcel, apiDownloadFile
} from '@/api/Util.js' 

export default {
  name: 'StatisticsTicketError',
  components: {
  
  },
  data: function () {
    return {
      filterData: {
        "start_at": new Date(new Date().setDate(new Date().getDate() - 7)).toLocaleDateString().replaceAll('/','-'),
        "end_at": new Date().toLocaleDateString().replaceAll('/','-'),
        "is_not_success": true
      },
      filterOptions: [
        {
          componentType:'date-picker',
          defaultValue: null,
          akey:'start_at',
          col:2,
          placeholder:'開始日期',
        },
        {
          componentType:'date-picker',
          defaultValue: null,
          akey:'end_at',
          col:2,
          placeholder:'結束日期',
        },
        {
          'componentType':'b-form-checkbox',
          'selectOptions':true,
          'optionVar':true,
          'defaultValue':true,
          'akey':'is_not_success',
          'col':2,
          'label':'',
          'placeholder':'只顯示錯誤紀錄',
          'title':'如果不打勾就是所有紀錄都顯示',
          'isRequired':true
        },
        {
          'componentType':'b-button',
          'placeholder':'下載報表',
          'akey':'download_result',
          'col':2,
          'execCallback': this.downloadResult
        },
      ],
    }
  },
  methods: {
    downloadResult: async function() {

      if (!this.filterData.start_at || !this.filterData.end_at) {
        this.$swal({
          'text': '請填入日期區間',
          'icon': 'info'
        })
        return
      }

      this.$swal({
        'text': '產出報表中...請稍候',
        'icon': 'info'
      })

      let result = await apiGetConfirmError(this.filterData).then(function(resp){
        return resp
      })

      console.log(result)

      let logs = result.data.data

      if (logs.length === 0){
        this.$swal({
          'text': '無錯誤紀錄',
          'icon': 'info'
        })
        return
      }
      let params = {
        "source": logs
      }

      result = await apiListToExcel(params).then(function(resp) {
        return resp
      })

      let download_url = result.data.data.url.replace('/api/ticket', '')

      let file_name = this.filterData.start_at + '_' + this.filterData.end_at
      let that = this
      result = apiDownloadFile(download_url).then(function(resp){
        that.$swal({
          'title':'產生完成！',
          'icon': 'success'
        })

        const url = window.URL.createObjectURL(new Blob([resp.data], {type:'application/vnd.ms-excel'}));
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', file_name + '.xlsx');
        document.body.appendChild(link);
        link.click();
      })
    },
  },
  created() {
  },
  mounted() {
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.preview_container{
  position: relative;
}
.preview_general{
  font-size: 12px;
  font-family: cwTeXKai, "Noto Serif TC", "Noto Sans SC", serif;
  font-weight: 300;
  position: absolute;
  top: 0px;
  left: 0px; 
  text-align: left;
  line-height: 1;
}
.total_no{
  top: 50px;
  left: 340px;
}
.order_no{
  top: 50px;
  left: 585px;
}
.barcode1{
  font-weight: 600;
  top: 12px;
  left: 700px;
}
.barcode2{
  font-weight: 600;
  top: 270px;
  left: 175px;
}
.qrcode1{
  font-weight: 600;
  top: 350px;
  left: 800px;
}
.p_name{
  top: 70px;
  left: 340px;
}
.p_remark1{
  top: 90px;
  left: 340px;
}
.p_price{
  top: 113px;
  left: 350px;
}
.p_end_date{
  top: 113px;
  left: 530px;  
}
.preview_content{
  /* z-index: 9999;  */
  top: 150px;
  left: 285px;
  width: 635px;
  height: 117.16px;
}
.s_firm{
  top: 280px;
  left: 370px;
}
.s_name{
  top: 297px;
  left: 530px;
}
.s_address{
  top: 315px;
  left: 370px;
}
.ss_firm{
  top: 345px;
  left: 340px;
}
.ss_invoice{
  top: 365px;
  left: 340px;
}
.ss_name{
  top: 383px;
  left: 340px;
}
.ss_address{
  top: 400px;
  left: 340px;
}
.ss_bank{
  top: 345px;
  left: 690px;
}
.ss_date{
  top: 363px;
  left: 690px;
}
.ss_period{
  top: 381px;
  left: 690px;
}
.ss_num{
  top: 400px;
  left: 690px;
}
.wrapper2 {
  height: 65vh;
  border-style: inset;
  max-height: 65vh;
}
.wrapper3 {
  height: 150px;
  overflow-y: scroll;
  border-style: inset;
}

</style>
